import React from "react";
export default (function (_ref) {
  var type = _ref.type,
    label = _ref.label,
    onClick = _ref.onClick,
    readonly = _ref.readonly,
    config = _ref.config;
  var typeToLabel = {
    "addRuleGroup": "+",
    "addRuleGroupExt": "+",
    "delGroup": "x",
    "delRuleGroup": "x",
    "delRule": "x"
  };
  var btnLabel = label || typeToLabel[type];
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    type: "button",
    disabled: readonly
  }, btnLabel);
});